/* eslint-disable import/no-unresolved */
import React, { Component, Fragment } from "react";
import { shape, func, string, number, arrayOf, bool } from "prop-types";
import { connect } from "react-redux";
import { push } from "react-router-redux";

import { actions as accountsActions, selectors as accountsSelectors } from "reducers/accounts";
import { actions as formActions } from "reducers/form";
import { selectors as sessionSelectors } from "reducers/session";
import { selectors as debinSelectors, actions as debinActions } from "reducers/debin";
import { selectors as transactionsSelectors, actions as transactionsActions } from "reducers/transactions";

import ContextMenu from "pages/_components/ContextMenu";
import IncomingDebinTransactionData from "pages/debinPayments/_components/IncomingDebinTransactionData";
import PageLoading from "pages/_components/PageLoading";
import TransactionTicket from "pages/_components/TransactionTicket";
import IncomingDebinSummaryData from "pages/debinPayments/_components/IncomingDebinSummaryData";
import Notification from "pages/_components/Notification";
import { resizableRoute } from "pages/_components/Resizable";

import * as i18n from "util/i18n";
import * as accountUtils from "util/accounts";
import { exportGenericTicketPdfWithSuccessMessage, getGeneralTicketItem } from "util/transaction";
import { isPullTrx } from "util/debin";

class IncomingDebinTransaction extends Component {
    static propTypes = {
        summary: shape({}).isRequired,
        dispatch: func.isRequired,
        accounts: shape({}),
        loggedUser: shape({
            accessToken: string,
            defaultAvatarId: string,
            email: string,
            previousLoginInfo: arrayOf(
                shape({
                    city: string,
                    country: string,
                    date: string,
                    idUser: string,
                    ip: string,
                    latitude: number,
                    longitude: number,
                }),
            ),
        }),
        debinDetail: shape({}).isRequired,
        fetching: bool,
        fetchingAccounts: bool,
        potentialSignaturesData: arrayOf(
            shape({ typesOfSignatures: arrayOf({ signature: string, selected: bool }), liberator: string }),
        ).isRequired,
        isDesktop: bool.isRequired,
        isSmallDesktop: bool.isRequired,
        pageToGoBack: string.isRequired,
        embeddedInV3Shell: bool,
    };

    static defaultProps = {
        embeddedInV3Shell: false,
        accounts: null,
        loggedUser: null,
        fetching: false,
        fetchingAccounts: false,
    };

    state = {
        showDrawerMobile: false,
        fetchingDownload: false,
    };

    componentDidMount() {
        const { summary, dispatch, loggedUser } = this.props;

        if (!summary && localStorage.getItem("flow")) {
            dispatch(push(`${JSON.parse(localStorage.getItem("flow"))}`));
        } else {
            const { idDebin } = summary;

            dispatch(debinActions.acceptIncomingRequestPre(idDebin));

            dispatch(accountsActions.listAccounts(loggedUser.userId));
            dispatch(transactionsActions.getPotentialSignaturesData(summary.idTransaction));
        }
    }

    signTransaction = () => {
        const {
            dispatch,
            summary,
            accounts,
            debinDetail: { buyerDetail },
        } = this.props;
        let accountName = null;

        if (accounts.length > 0) {
            const loggedUserAccount = accountUtils.getUserAccount(accounts, buyerDetail?.cbu);
            accountName = accountUtils.getIncomingDebinAccountName(loggedUserAccount);
        }
        const signTransactionData = (
            <IncomingDebinSummaryData {...this.props} FORM_ID="payments.debin" accountName={accountName} signature />
        );
        dispatch(push("/transactions/sign"));
        const isChargebackRecurrency = summary?.idActivity === "chargeback.recurrency";
        const isChargebackPull = summary?.idActivity === "chargeback.pull";
        let title;
        if (isChargebackRecurrency) {
            title = "payments.debin.chargeback.recurrency.summary";
        } else if (isChargebackPull) {
            title = "payments.debin.chargebackPull.summary";
        } else {
            title = "payments.debin.table.menu.accept";
        }
        dispatch(
            formActions.signTransactionData({
                idTransaction: summary?.idTransaction,
                idActivity: summary.idActivity,
                idForm: "",
                content: signTransactionData,
                title,
                pendingDispatch: summary?.pendingDispatch,
            }),
        );

        dispatch(
            formActions.signTransactionPreview({
                idActivity: summary.idActivity,
                idTransaction: summary.idTransaction,
                idForm: "",
                ticketData: summary,
            }),
        );

        dispatch(debinActions.loadConfirmIncomingDebin({ ...summary, action: "sign" }));
    };

    exportPdf = async () => {
        this.setState({ fetchingDownload: true });
        const { summary, debinDetail, accounts, dispatch } = this.props;
        const {
            sellerDetail,
            amount: { currency, quantity },
            buyerDetail,
            idVoucher,
            concept,
            expirationDate,
            description,
        } = debinDetail;
        let accountName = null;

        if (accounts.length > 0) {
            const loggedUserAccount = accountUtils.getUserAccount(accounts, buyerDetail?.cbu);
            accountName = accountUtils.getIncomingDebinAccountName(loggedUserAccount);
        }

        const isChargebackRecurrency = summary?.idActivity === "chargeback.recurrency";
        let summaryTitle;
        if (isPullTrx(debinDetail.type)) {
            summaryTitle = "payments.debin.chargebackPull.summary";
        } else if (isChargebackRecurrency) {
            summaryTitle = "payments.debin.chargeback.recurrency.summary";
        } else {
            summaryTitle = "payments.debin.confirm.summary";
        }

        const descriptionLabel = isChargebackRecurrency
            ? "payments.debin.detail.table.header.installment"
            : "payments.debin.detail.table.header.description";

        const ticketData = {
            ticketName: i18n.get(summaryTitle),
            ticketBody: [
                getGeneralTicketItem("negotiate.transaction.date.label", summary?.submitDateTime, "datefulltime"),
                getGeneralTicketItem(
                    "pay.paymentAFIP.idTransaction",
                    summary?.idTransaction.substring(0, 8).toUpperCase(),
                    "string",
                ),
                getGeneralTicketItem("payments.debin.confirm.table.header.debitAccount", accountName, "string"),
                ...(isPullTrx(debinDetail.type)
                    ? [
                          getGeneralTicketItem(
                              "payments.debin.confirm.table.header.trxpll.id",
                              summary?.idDebin,
                              "string",
                          ),
                      ]
                    : [getGeneralTicketItem("payments.debin.confirm.table.header.id", summary?.idDebin, "string")]),
                getGeneralTicketItem(
                    `payments.debin.confirm.table.header.type${sellerDetail.cbu?.startsWith("000") ? "cvu" : "cbu"}`,
                    sellerDetail.cbu,
                    "string",
                ),
                getGeneralTicketItem(
                    "payments.debin.confirm.table.header.creditAccount",
                    accountUtils.getAccountNumber(sellerDetail.cbu),
                    "string",
                ),
                getGeneralTicketItem(
                    "payments.debin.detail.table.header.documentType",
                    sellerDetail.documentType.concat(" ", sellerDetail.documentNumber),
                    "string",
                ),
                getGeneralTicketItem("payments.debin.detail.table.header.sender", sellerDetail.titular, "string"),
                getGeneralTicketItem(
                    `payments.debin.confirm.table.header.${sellerDetail.cbu?.startsWith("000") ? "entity" : "bank"}`,
                    sellerDetail.bank && sellerDetail.bank !== "000" ? sellerDetail.bank : "-",
                    "string",
                ),
                ...(isPullTrx(debinDetail.type)
                    ? []
                    : [
                          getGeneralTicketItem(
                              "payments.debin.detail.table.header.reference",
                              debinDetail.refence || "",
                              "string",
                          ),
                      ]),
                getGeneralTicketItem(
                    "payments.debin.detail.table.header.amount",
                    quantity,
                    currency === "032" ? "amountARS" : "amountUSD",
                ),
                ...(isPullTrx(debinDetail.type)
                    ? []
                    : [getGeneralTicketItem("payments.debin.detail.table.header.voucher", idVoucher, "string")]),
                getGeneralTicketItem(
                    "payments.debin.detail.table.header.concept",
                    concept ? `${concept} - ${i18n.get(`transfers.concept.${concept}`)}` : "",
                    "string",
                ),
                getGeneralTicketItem("payments.debin.table.header.expiration", expirationDate, "datetime"),
                getGeneralTicketItem(descriptionLabel, description, "string"),
            ],
        };

        await exportGenericTicketPdfWithSuccessMessage(ticketData, dispatch, i18n.get("global.download.success"));

        this.setState({ fetchingDownload: false });
    };

    centerContentMobile = () => {
        const { summary } = this.props;
        const isChargebackRecurrency = summary?.idActivity === "chargeback.recurrency";
        const summaryTitle = isChargebackRecurrency
            ? "payments.debin.chargeback.recurrency.summary"
            : "payments.debin.confirm.summary";

        return (
            <div className="title-account-header-multiline-background-blue">
                <h1 style={{ width: "100%", marginTop: "2px" }}>{i18n.get(summaryTitle)}</h1>
            </div>
        );
    };

    buttonsDetail = () => {
        const { dispatch, summary } = this.props;

        if (summary?.idTransactionStatus !== "PENDING") {
            return [
                {
                    label: "global.goToHome",
                    bsStyle: "primary",
                    onClick: () => dispatch(push("/desktop")),
                },
            ];
        }
        return [
            {
                label: "global.goToHome",
                bsStyle: "outline",
                onClick: () => dispatch(push("/desktop")),
            },
        ];
    };

    rightContentTransactionScheme = (isFinished, isPending) => {
        const { isDesktop, summary } = this.props;

        if (isDesktop || isFinished || !isPending) {
            return <></>;
        }

        return (
            <>
                {summary?.idTransactionStatus !== "CANCELLED" && (
                    <ContextMenu
                        isDesktop={isDesktop}
                        color="white"
                        buttonClassName="align-self-center account-dropdown-header-font font-black-alpha ml-2"
                        items={[
                            {
                                label: "pendingTransaction.info.scheme",
                                onClick: () => this.setState({ showDrawerMobile: true }),
                            },
                        ]}
                    />
                )}
            </>
        );
    };

    renderContent = () => {
        const { summary, debinDetail, accounts, isDesktop, fetching, embeddedInV3Shell, pageToGoBack } = this.props;
        const { showDrawerMobile, fetchingDownload } = this.state;
        const { buyerDetail } = debinDetail;
        let accountName = null;

        if (accounts.length > 0) {
            const loggedUserAccount = accountUtils.getUserAccount(accounts, buyerDetail?.cbu);
            accountName = accountUtils.getIncomingDebinAccountName(loggedUserAccount);
        }

        const isFinished = summary.idTransactionStatus === "FINISHED";
        const isPending = summary.idTransactionStatus === "PENDING";
        const isChargebackRecurrency = summary?.idActivity === "chargeback.recurrency";
        const isChargebackPull = summary?.idActivity === "chargeback.pull";
        let summaryTitle;
        if (isChargebackRecurrency) {
            summaryTitle = "payments.debin.chargeback.recurrency.summary";
        } else if (isChargebackPull) {
            summaryTitle = "payments.debin.chargebackPull.summary";
        } else {
            summaryTitle = "payments.debin.confirm.summary";
        }

        return (
            accounts &&
            debinDetail &&
            summary && (
                <TransactionTicket
                    embeddedInV3Shell={embeddedInV3Shell}
                    embeddedV3GoBackPath={pageToGoBack || "/payments/payDebin"}
                    notificationScope="forms"
                    handleClick={this.exportPdf}
                    downloadImageWhite={!isDesktop}
                    handleClickMessage="global.download"
                    headerClassName={!isDesktop ? "blue-main-header-mobile blue-main-title-mobile" : ""}
                    centerElement={isDesktop ? undefined : this.centerContentMobile}
                    uniqueDownload={isFinished}
                    rightContent={() => this.rightContentTransactionScheme(isFinished, isPending)}
                    hasInlineButtons
                    hideMobileMenu={!isDesktop}
                    summary={summary}
                    fetching={fetching}
                    buttonsDetail={this.buttonsDetail()}
                    isDesktop={isDesktop}
                    summaryTitle={summaryTitle}
                    showDrawerMobile={showDrawerMobile}
                    onSignTicket={this.signTransaction}
                    ignoreHomeButton
                    closeMobileDrawer={() => this.setState({ showDrawerMobile: false })}
                    isFetchingExport={fetchingDownload}>
                    <IncomingDebinTransactionData {...this.props} accountName={accountName} />
                </TransactionTicket>
            )
        );
    };

    render() {
        const { fetching, debinDetail, fetchingAccounts, accounts } = this.props;

        const { embeddedInV3Shell } = this.props;

        return (
            <Fragment>
                <PageLoading loading={fetching || fetchingAccounts}>
                    {!embeddedInV3Shell && <Notification scopeToShow="debinTransaction" />}

                    {!fetching && debinDetail && accounts && this.renderContent()}
                </PageLoading>
            </Fragment>
        );
    }
}

const mapStateToProps = (state) => ({
    summary: debinSelectors.getSummary(state),
    debinDetail: debinSelectors.getDebinDetail(state),
    loggedUser: sessionSelectors.getUser(state),
    fetchingAccounts: accountsSelectors.getFetching(state),
    accounts: accountsSelectors.getAccounts(state),
    fetching: debinSelectors.getFetching(state),
    potentialSignaturesData: transactionsSelectors.getPotentialSignaturesData(state),
    pageToGoBack: debinSelectors.getPageToGoBack(state),
});

export default connect(mapStateToProps)(resizableRoute(IncomingDebinTransaction));
